// Original homepage disabled — see Home.original.js to restore.
import SiteClosed from './SiteClosed';

export default SiteClosed;
